import React from 'react';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';
import { moneyFormat } from 'helpers/moneyFormat';
import { HospitalProcedure } from 'types/hospital';

interface HospitalProceduresListProps {
  procedures: HospitalProcedure[];
  handleDeleteProcedure(procedure: HospitalProcedure, index: number): void;
  handleEditProcedure(procedure: HospitalProcedure, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'procedure', label: 'Procedimento' },
  { id: 'min', label: 'Mínimo', align: 'right', width: '130px' },
  { id: 'max', label: 'Máximo', align: 'right', width: '130px' },
];

const HospitalProceduresList: React.FC<HospitalProceduresListProps> = ({
  procedures,
  handleDeleteProcedure,
  handleEditProcedure,
}) => (
  <RecordList
    columns={columns}
    rows={procedures.map((procedure, index) => ({
      key: procedure.id || index,
      values: {
        procedure: procedure.procedure?.name || '-',
        min: moneyFormat(procedure.sale_price_min),
        max: moneyFormat(procedure.sale_price_max),
      },
    }))}
    onEdit={index => handleEditProcedure(procedures[index], index)}
    onDelete={index => handleDeleteProcedure(procedures[index], index)}
  />
);

export default HospitalProceduresList;
